/**
 * Created by Omar Alejandro Leonor Avalos on 2017-09-11.
 * Logout modal
 */
import React, { Component } from 'react';
import { FlatButton, Dialog } from 'material-ui';
import PropTypes from 'prop-types';

class ConfirmFialog extends Component {
    render() {
        const { open, onCancel, onConfirm, okLabel, cancelLabel, title, message } = this.props;
        const actions = [
            <FlatButton
                label={cancelLabel}
                primary
                onClick={() => onCancel()}
            />,
            < FlatButton
                label={okLabel}
                primary
                keyboardFocused
                onClick={() => onConfirm()}
            />
        ];

        return (
            <Dialog
                title={title}
                actions={actions}
                modal={false}
                open={open}
                onRequestClose={() => { }}
            >
                {message}
            </Dialog>
        );
    }
}

ConfirmFialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    okLabel: PropTypes.string.isRequired,
    cancelLabel: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
};

ConfirmFialog.defaultProps = {
    onCancel: () => {},
    okLabel: 'Aceptar',
    message: 'Default Message (message)',
    cancelLabel: 'Cancelar',
    title: 'Default Title (message)'
};

export default ConfirmFialog;



// WEBPACK FOOTER //
// ./modals/confirmation.js